import { gql } from '@apollo/client';

export const GET_HANDOVER_DRIVER_NAMES = gql`
    query GetHandoverDriverNames($warehouseId: Long!) {
        getHandoverDriverNames(warehouseId: $warehouseId)
    }
`;

export const GET_HANDOVER_LICENSE_PLATES = gql`
    query GetHandoverLicensePlates($warehouseId: Long!) {
        getHandoverLicensePlates(warehouseId: $warehouseId)
    }
`;

export interface GetHandoverDriverNamesResponse {
    getHandoverDriverNames: string[];
}

export interface GetHandoverLicensePlatesResponse {
    getHandoverLicensePlates: string[];
}
